import baseRequest from "../_core/baseRequest";

export default {
    getPendingPayments: params => baseRequest.post("/cod-payment/pending-payments", params),
    getCanceledPayments: params => baseRequest.post("/cod-payment/canceled-payments", params),
    getSuccessPayments: params => baseRequest.post("/cod-payment/success-payments", params),
    getPastPeriods: params => baseRequest.post("/cod-payment/past-periods", params),
    addPaymentToReference: params =>
        baseRequest.post("/cod-payment/add-payment-to-reference", params),
    getPendingInvoicePayments: params =>
        baseRequest.post("/cod-payment/pending-invoice-payments", params),
    excelExportPendingInvoicePayments: params =>
        baseRequest.post("/cod-payment/pending-invoice-payments/excel-export", params),
    assignInvoiceToPayment: params => baseRequest.post("/cod-payment/assign-invoice", params),
    approvePayment: params => baseRequest.post("/cod-payment/approve-cash-payment", params),
    getHasInvoicePayments: params => baseRequest.post("/cod-payment/has-invoice-payments", params),
    getCompletedPayments: params => baseRequest.post("/cod-payment/completed-payments", params),
    getFailedPayments: params => baseRequest.post("/cod-payment/failed-payments", params),
    getConvertedToCashPayments: params =>
        baseRequest.post("/cod-payment/list-converted-to-cash-payments", params),
    getPaidByBothCashAndCardPayments: params =>
        baseRequest.post("/cod-payment/paid-by-both-cash-and-pos", params),
    checkPaymentStatusOnPos: params =>
        baseRequest.post("/cod-payment/check-payment-status-on-pos", params),
    approvePaymentReferences: params =>
        baseRequest.post("/cod-payment/approve-payment-references", params),
    listCourierTerminals: params => baseRequest.post("/cod-payment/courier-terminals", params),
    paymentTypes: params => {
        console.log("Service params:", params);
        return baseRequest.apiRequest(
            "GET",
            "/cod-payment/payment-types",
            null,
            params.apiKey,
            params.token
        );
    },
    getPaymentsSummary: params => {
        return baseRequest.post('/cod-payment/payment-summary', params);
    },

    getPaymentsSummaryList: params => {
        return baseRequest.post('/cod-payment/payment-summary/list', params);
    }
};
